import { render } from "./EditPaymentLiquidation4.vue?vue&type=template&id=51ac72a6"
import script from "./EditPaymentLiquidation4.vue?vue&type=script&lang=js"
export * from "./EditPaymentLiquidation4.vue?vue&type=script&lang=js"

import "./EditPaymentLiquidation4.vue?vue&type=style&index=0&id=51ac72a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__